<!-- Nom à gauche, barres à droite sur la même ligne. La colonne du nom (w-36)
     est aussi celle de l'axe des mois, dans l'en-tête collant du calendrier. -->
<button type="button" class="cal-row flex w-full min-h-target items-center gap-2 py-1 text-left" (click)="onClick()"
  [attr.aria-expanded]="type === 'hierarchy' ? isOpen : null">
  <span class="flex w-36 shrink-0 items-center gap-2">
    <span class="w-8 shrink-0">
      <vw-cultivation-item-viewer [cultivation]="cultivation" [displayType]="'TINY'"></vw-cultivation-item-viewer>
    </span>
    <span class="flex grow min-w-0 flex-col">
      <span class="line-clamp-2 text-body-s font-semibold text-vw-ink">{{ name ?? cultivation.name }}</span>
      @if (badge) {
        <span class="max-w-full self-start truncate rounded-full bg-vw-surface-tint px-1.5 text-caption text-vw-primary-ink">{{ 'calendar.badge.' + badge | translate }}</span>
      }
    </span>
    @if (type === 'hierarchy') {
      <span class="w-4 shrink-0 text-vw-icon-idle transition-transform duration-300" [class.rotate-90]="isOpen">
        <vw-chevron-right-icon></vw-chevron-right-icon>
      </span>
    }
  </span>
  <!-- Les barres sur la grille des mois, sur toute la hauteur de la ligne. -->
  <span class="relative flex grow min-w-0 items-center self-stretch">
    <span class="absolute inset-0 grid grid-cols-12" aria-hidden="true">
      @for (m of monthNumbers; track m) {
        <span class="border-l border-vw-surface-sunk"></span>
      }
    </span>
    <span class="relative w-full">
      <vw-calendar-period-line [periods]="periods" [dense]="true"></vw-calendar-period-line>
    </span>
  </span>
</button>
